<template>
  <md-toolbar
    md-elevation="0"
    class="scs-navbar"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle hamburger-nav"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <md-list-item href="#/projectportal">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item>

            <md-list-item href="#/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
            <md-list-item >
              <md-button class="md-small md-info" href="tel:7082311111">Call Now | 708-231-1111</md-button>
            </md-list-item>
            <md-list-item @click="logoutUser">
              <md-button class="md-small md-info">Logout</md-button>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    logoutUser(){
      this.$store
        .dispatch("signOut", {})
        .then(() => {
          this.$router.push('/portallogin')
        })
    }
  }
};
</script>
<style lang="scss">
  .md-toolbar {
    background-color: white !important;
    .md-title {
      color: #033860 !important;
      font-weight: bold;
    }
    .md-list-item {
      i {
        color: #033860 !important;
      }
    }
    md-autocomplete {
      .md-field:before {
        background-color: #033860 !important;
      }
    }
  }
  // .hamburger-nav {
  //   background-color: transparent !important;
  // }
</style>
